export const QWIKBOX_STORAGE_BASE_URL = 'https://storage.qwikcut.com';
export const QWIKBOX_S3_URL = 'https://qwikbox.s3.us-east-1.amazonaws.com';
